// @flow
import React, { Component } from 'react'
import { connect } from 'react-redux'
import qs from 'qs'
import { Switch, Route, withRouter } from 'react-router-dom'
import store from './state/store'
import { fetchClient } from './state/client/actions'
import { restoreLearner } from './state/learner/actions'
import styled from 'styled-components'
import { isProduction } from './utils'

import {
  QuizScreen,
  StartScreen,
  CompleteScreen,
  InformationScreen,
  InstructionsScreen,
  CommencementCheckScreen,
  LearnerFormScreen,
  DeclarationScreen,
  WelcomeBackScreen,
  IntermissionScreen,
  MissScreen,
  QuizDisabledScreen,
  TrialQuizDisabledScreen,
  QuizTypeDisabledScreen,
  DlrqStartScreen,
  QuizCompleteScreen,
  DlrqInfoScreen,
  DlrqQuizScreen,
  DpStartScreen,
  DlrqCompleteScreen,
  DpLearnerFormScreen,
  DpQuizScreen,
  DpInfoScreen,
  DlrqLearnerFormScreen,
  DpResultGenerate,
  DpConfirmResetScreen
} from './screens'

import UnsupportedBrowerWarning from './lib/check-browser-compatability'

// min-height: 625px;
// min-width: 980px;

const Base = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  background: linear-gradient(to bottom, #2C9DA3, #4DB8BE, white);
  overflow: auto;
`

/**
 * Top-level components, composes all screens
 * @memberof components/Screens
 */
class App extends Component {
  componentDidMount() {
    // eslint-disable-next-line no-console
    // Initialise the client
    this.props.fetchClient()
    // Initialise the learner
    const { invite, goToQuestion } = qs.parse(window.location.search, {
      ignoreQueryPrefix: true,
    })
    if (invite) {
      this.props.restoreLearner(invite)
    }
    if (!isProduction() && goToQuestion != null) {
      store.dispatch({
        type: 'SUBMIT_ANSWER_PENDING',
        payload: {
          answer: { questionId: 'mock', answer: { mock: true } },
          nextQuestionRequest: goToQuestion,
        },
      })
      this.props.history.push('/quiz')
    }
  }
  render() {

    const state = store.getState()
    return (
      <Base testLevel={state.learner.testLevel} style={{backgroundColor: state.learner.testLevel === 'dp' ? '#11ACA2': '#2C9DA3'}}>
        <UnsupportedBrowerWarning />
        <Switch>
          <Route path="/" exact component={StartScreen} />
          <Route path="/complete" component={CompleteScreen} />
          <Route path="/information" component={InformationScreen} />
          <Route path="/instructions" component={InstructionsScreen} />
          <Route
            path="/commencement-check"
            component={CommencementCheckScreen}
          />
          <Route path="/learner-form" component={LearnerFormScreen} />
          <Route path="/dlrq-learner-form" component={DlrqLearnerFormScreen} />
          <Route path="/declaration" component={DeclarationScreen} />
          <Route path="/welcome-back" component={WelcomeBackScreen} />
          <Route path="/disabled" component={QuizDisabledScreen} />
          <Route path="/trial-disabled" component={TrialQuizDisabledScreen} />
          <Route path="/type-disabled" component={QuizTypeDisabledScreen} />
          <Route path="/intermission" component={IntermissionScreen} />
          <Route path="/quiz" component={QuizScreen} />
          <Route path="/dlrq-start" component={DlrqStartScreen} />
          <Route path="/dlrq-information" component={DlrqInfoScreen} />
          
          <Route path="/dlrq-complete" component={DlrqCompleteScreen} />
          <Route path="/dlrq" component={DlrqQuizScreen} />
          <Route path="/quiz-complete" component={QuizCompleteScreen} />
          <Route path="/dp-result-generate" exact component={DpResultGenerate} />
          <Route path="/dp-start" component={DpStartScreen} />
          <Route path="/dp-learner-form" component={DpLearnerFormScreen} />
          <Route path="/dp" component={DpQuizScreen} />
          <Route path="/dp-information" component={DpInfoScreen} />
          <Route path="/dp-confirm-reset" component={DpConfirmResetScreen} />
          <Route component={MissScreen} />
        </Switch>
      </Base>
    )
  }
}

// wrapping with router here to force an update of the component
// see discussion https://github.com/reactjs/react-redux/issues/507 for details
export default withRouter(connect(null, { fetchClient, restoreLearner })(App))



// WEBPACK FOOTER //
// ./src/App.js